import { generateEntityId } from "../entity-model/entity.js";
import { generateOperationId } from "../operation/operation.js";
/**
 * @see {@link RemoveModelOperation}
 */
export const RemoveModelOperationType = "https://schemas.dataspecer.com/project-model/operations/delete-model";
export function createRemoveModelOperation(modelId) {
    if (!(typeof modelId === "string" && modelId.length > 0)) {
        throw new Error("Invalid model identifier.");
    }
    return {
        id: generateOperationId(),
        type: RemoveModelOperationType,
        modelId,
    };
}
export function isRemoveModelOperation(operation) {
    return operation.type === RemoveModelOperationType;
}
/**
 * @see {@link CreateModelOperation}
 */
export const CreateModelOperationType = "https://schemas.dataspecer.com/project-model/operations/create-model";
/**
 * Creates a new operation that will create a new model. ID of such model is
 * pre-generated, but can be overridden by the caller.
 *
 * You need to specify model type.
 *
 * Usually you do not want to use this operation directly as you also need to
 * initialize the model with its own operations. Therefore, use functions that
 * generate both the model and the initial entities in the model at once.
 */
export function createCreateModelOperation(parentPackageId, modelType, modelId) {
    return {
        id: generateOperationId(),
        type: CreateModelOperationType,
        parentPackageId,
        modelId: modelId ?? generateEntityId(),
        modelType,
    };
}
export function isCreateModelOperation(operation) {
    return operation.type === CreateModelOperationType;
}
/**
 * @see {@link CreateProjectOperation}
 */
export const CreateProjectOperationType = "https://schemas.dataspecer.com/project-model/operations/create-project";
export function createCreateProjectOperation(projectId) {
    if (!(typeof projectId === "string" && projectId.length > 0)) {
        throw new Error("Invalid project identifier.");
    }
    return {
        id: generateOperationId(),
        type: CreateProjectOperationType,
        projectId,
    };
}
export function isCreateProjectOperation(operation) {
    return operation.type === CreateProjectOperationType;
}
//# sourceMappingURL=operations.js.map